<script lang="ts">
	import { type ErrorMessage, getContextErrors } from '../errors'
	import { createEventDispatcher } from 'svelte'
	import { type EventHandler } from 'svelte/elements'

	interface Props {
		name?: string | null
		id?: string | null
		class?: string | null
		children?: import('svelte').Snippet
		onsubmit?: EventHandler<SubmitEvent & { currentTarget: EventTarget & Element }>
		onError?: (errors: { [key: string]: ErrorMessage }) => void
	}

	let {
		name = null,
		id = null,
		class: className = null,
		children,
		onsubmit,
		onError,
	}: Props = $props()

	const dispatch = createEventDispatcher()

	const errors = getContextErrors()

	function hasSomeErrorTextKey(errors: { [key: string]: ErrorMessage }) {
		return errors && Object.values(errors).some((error) => Boolean(error?.text))
	}

	let noErrors = $derived(!hasSomeErrorTextKey($errors))

	function handleSubmit(event: SubmitEvent & { currentTarget: EventTarget & Element }) {
		event.preventDefault()
		if (noErrors) {
			dispatch('submit', event)
			onsubmit?.(event)
		} else {
			onError?.(Object.fromEntries(Object.entries($errors).filter(([_, error]) => error?.text)))
		}
	}
</script>

<form {id} {name} class={className} onsubmit={handleSubmit}>
	{@render children?.()}
</form>
